/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRegimen } from 'app/shared/model/regimen.model';
import { IRegimenCycle } from 'app/shared/model/regimen-cycle.model';
import { IImageTests } from 'app/shared/model/image-tests.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';

export interface IRegimenInvestigation {
  id?: string;
  cycleNumber?: number | null;
  associationType?: keyof typeof AssociationType | null;
  noteOrInstructions?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  regimen?: IRegimen | null;
  cycle?: IRegimenCycle | null;
  imageTest?: IImageTests | null;
  panel?: IDiagLabPanel | null;
  labTestItem?: ILabTestItem | null;
}

export const defaultValue: Readonly<IRegimenInvestigation> = {
  active: false,
};
